__turbopack_context__.v({
  "actions": "fMHI5W_actions",
  "banner": "fMHI5W_banner",
  "body": "fMHI5W_body",
  "close": "fMHI5W_close",
  "copy": "fMHI5W_copy",
  "cta": "fMHI5W_cta",
  "period": "fMHI5W_period",
  "stack": "fMHI5W_stack",
  "title": "fMHI5W_title",
});
